export enum SalesCommissionStatusEnum {
  PREVIEW = 1,
  AVAILABLE = 2,
  PAID = 3,
  EXPIRED = 4,
  REQUESTED = 5,
  TO_RECEIVE = 6,
  CREDITED = 7,
  REVERSED = 8,
  ADVANCED = 9,
}

export enum SalesCommissionStatusDTOEnum {
  Prévia = 1,
  Disponível = 2,
  Paga = 3,
  Expirada = 4,
  Solicitada = 5,
  'A Receber' = 6,
  Creditada = 7,
  Estornada = 8,
  Antecipada = 9,
}
